import { render, staticRenderFns } from "./UserWithdrawTable.vue?vue&type=template&id=66fa73a8&scoped=true"
import script from "./UserWithdrawTable.vue?vue&type=script&lang=js"
export * from "./UserWithdrawTable.vue?vue&type=script&lang=js"
import style0 from "./UserWithdrawTable.vue?vue&type=style&index=0&id=66fa73a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa73a8",
  null
  
)

export default component.exports